import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";
import classnames from "classnames";
import sizeMe from "react-sizeme";

import AppsFeature from "./nounproject-appsfeature";
import IconAPICustomBlock from "./nounproject-customblock-icon-api";
import BestCollection from "./nounproject-best-collection";
import BlogCarousel from "./nounproject-blog-carousel";
import FeaturedCollection from "./nounproject-featured-collection";
import Footer from "./nounproject-footer";
import IconsForEverythingHeader from "./nounproject-icons-everything-header";
import PrePaidCustomBlock from "./nounproject-customblock-prepaid";
import DiversityCustomBlock from "./nounproject-customblock-diversity";
import NounProjectSearch from "./nounproject-search";
import Sticky from "react-stickynode";
import TentPoles from "./nounproject-tentpoles";
import UserCarousel from "./nounproject-creator-carousel";
import Inview from "./inview";

require("../../sass/components/nounproject-homepage.sass");

class NounProjectHomepage extends React.PureComponent {
    componentWillMount() {
        this.props.fetchFeaturedCollectionMetaData();
    }

    constructor(props) {
        super(props);
        // dismiss old welcome modal
        $("#welcome_screen .inner .button").on("click", e => {
            e.preventDefault();
            $("#welcome_screen").removeClass("visible");
        });

        this.state = {
            featuredCollections: [],
            searchBarZ: 1
        };
    }

    render() {
        // if (this.props.featuredCollectionsKeys.length > 0) {
        let featuredCollections = this.props.featuredCollectionsKeys.map(
            collectionId => this.props.collections[collectionId]
        );

        let featuredCollectionComponents;
        if (featuredCollections.length) {
            featuredCollectionComponents = (
                <React.Fragment>
                    <FeaturedCollection
                        collectionIndex={0}
                        adSpace={true}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <AppsFeature />
                    <FeaturedCollection
                        collectionIndex={1}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <DiversityCustomBlock />
                    <FeaturedCollection
                        collectionIndex={2}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <UserCarousel />
                    <FeaturedCollection
                        collectionIndex={3}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                    <IconAPICustomBlock />
                    <FeaturedCollection
                        collectionIndex={4}
                        maxIcons={12}
                        collectionMetadata={featuredCollections}
                    />
                </React.Fragment>
            );
        }

        let handleStateChange = status => {
            if (status.status === Sticky.STATUS_FIXED) {
                $("body").addClass("search-is-sticky");
            } else {
                $("body").removeClass("search-is-sticky");
            }
        };

        let classes = classnames("homepage-container ");
        let stickyOffset = this.props.hasTopBanner ? 50 : 0;
        let enableTransforms = !this.props.hasTopBanner;
        return (
            <section className={classes}>
                <IconsForEverythingHeader />
                <Sticky
                    enableTransforms={enableTransforms}
                    top={stickyOffset}
                    activeClass="stuck-searchbar"
                    onStateChange={handleStateChange}
                >
                    <div className="homepage-search">
                        <NounProjectSearch />
                    </div>
                </Sticky>
                <BestCollection />
                <TentPoles />
                <PrePaidCustomBlock />
                {featuredCollectionComponents}
                <BlogCarousel />
                <Footer />
            </section>
        );
        // } else {
        //     return null;
        // }
    }
}

function mapStateToProps(state, ownProps) {
    let hasTopBanner = !!Object.keys(state.banners.all).length;
    return {
        featuredCollectionsKeys: state.collections.keys || [],
        collections: state.collections,
        hasTopBanner
    };
}

export default connect(
    mapStateToProps,
    {
        fetchFeaturedCollectionMetaData: actions.fetchFeaturedCollectionMetaData
    }
)(NounProjectHomepage);
